import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox } from '@mui/material';
import styled, { inputImages, inputNumbers, inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import { StudenMenu, userMenu, Zones } from '../TitleList';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { getCurrentDate } from '../../Utils/Dateutils';
import { fetchUserPages, insertStudenEntry, insertSubUser } from '../../Store/PHPSlice/zone';
import Dropdown from '../FieldsComponents/Dropdown';
import { fetchLocationData } from '../../Store/PHPSlice/LocationApi';
import { selectLocations, selectUserPages } from '../Selectors/Master/OutwardSelectors';
import RadioComponent from '../FieldsComponents/RadioComponent';
import CheckboxComponent from '../FieldsComponents/CheckboxComponent';


const UserRegEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        Uname: '',
        ph: '',
        userNm: '',
        dt: getCurrentDate(),
        pass: '',
        role: '2',
        pageAss: '',
        schlId: '',
        saleEntry: '0',
        stockReg: '0',
        stockDetails: '0',
        delete: '0',
        userId: userdata?.ID
    });

    const [selectedRows, setSelectedRows] = useState([]);
    const [tableData, setTableData] = useState([]);
    const schldata = useSelector(selectLocations);
    const upages = useSelector(selectUserPages);
    const dispatch = useDispatch();

    const checkboxOptions = [
        { name: 'saleEntry', label: 'Sale Entry' },
        { name: 'stockReg', label: 'Stock Register' },
        { name: 'stockDetails', label: 'Stock Details' },
        { name: 'delete', label: 'Delete' }
    ];

    useEffect(() => {
        dispatch(fetchLocationData());
        dispatch(fetchUserPages());
    }, [dispatch]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const isDesktop = useMediaQuery('(min-width:768px)');

    const fieldsecond = [
        { label: 'Date', name: 'dt', type: 'date' },
    ];

    const fieldsecond2 = [
        { label: 'Name', name: 'Uname' },
        { label: 'User Id', name: 'userNm' },
        { label: 'Contact', name: 'ph' },
        { label: 'Password', name: 'pass' }
    ];

    const pageAssign = [
        { label: 'Sale Entry', ID: 'saleEntry' },
        { label: 'Stock Register', ID: 'stockReg' },
        { label: 'Stock Inward', ID: 'stockInward' },
        { label: 'Stock Details', ID: 'stockDetails' },
    ];

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        // switch (dropdownType) {
        //     case 'schlId':
        //         if (value) {
        //             const selectObj = schldata?.data?.find(val => val.ID === value);
        //             // console.log(selectObj);
        //             if (selectObj) {
        //                 const isAlreadyAdded = tableData.some(item => item.ID === selectObj.ID);

        //                 if (!isAlreadyAdded) {

        //                     setTableData(prev => [...prev, selectObj]);

        //                     setFormData({
        //                         ...formData,
        //                         schlId: ''
        //                     });
        //                 } else {
        //                     alert("This School is already Exists.");
        //                     setFormData({
        //                         ...formData,
        //                         schlId: ''
        //                     });
        //                 }
        //             }
        //         };
        //         break;
        //     default:
        //         break;
        // }
    };
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: checked ? '1' : '0'
        }));
    };

    const handleCheckboxChange2 = (e, index) => {
        setSelectedRows(prev =>
            prev.includes(index)
                ? prev.filter(i => i !== index)
                : [...prev, index]
        );
    };
    const handleDelete = () => {
        setTableData(prev => prev.filter((_, index) => !selectedRows.includes(index)));
        setSelectedRows([]); // clear selection
    };

    const roleOptions = [
        { label: 'User', ID: '2' },
        { label: 'Admin', ID: '3' },
    ];
    const dropdownOrdType = [
        {
            label: 'Role',
            id: 'role',
            options: roleOptions || [],
            value: formData.role,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'role', value: newValue ? newValue.ID : '' } }, 'role'),
            getOptionLabel: (option) => `${option.label}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            color: 'blue',
            bold: true
        },
        {
            label: 'School',
            id: 'schlId',
            options: schldata?.data || [],
            value: formData.schlId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlId', value: newValue ? newValue.ID : '' } }, 'schlId'),
            getOptionLabel: (option) => `${option.schlcd}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            color: 'blue',
            bold: true
        },
        {
            label: 'Pages Assign',
            id: 'pageAss',
            options: upages?.data || [],
            value: formData.pageAss,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'pageAss', value: newValue ? newValue.ID : '' } }, 'pageAss'),
            getOptionLabel: (option) => option.pages || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        }

    ];

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function postObj() {
        const data = {
            Uname: formData.Uname,
            ph: formData.ph,
            userNm: formData.userNm,
            pass: formData.pass,
            role: formData.role,
            saleEntry: formData.saleEntry,
            stockReg: formData.stockReg,
            stockDetails: formData.stockDetails,
            tableData: groupBySchoolWithPages(tableData),
            userId: formData.userId
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.Uname === '') {
            alert('Please Enter Name');
            return;
        }
        if (formData.ph === '') {
            alert('Please Enter Contact');
            return;
        }
        if (formData.userNm === '') {
            alert('Please Enter User Id');
            return;
        }
        if (formData.pass === '') {
            alert('Please Enter Password');
            return;
        }
        // if (formData.saleEntry === '0' && formData.stockReg === '0' && formData.stockDetails === '0') {
        //     alert('Please Select Page Assign');
        //     return;
        // }
        const postobj = postObj(formData, tableData);
        // console.log(postobj);


        dispatch(insertSubUser(postobj))
            .unwrap()
            .then((result) => {
                console.log('POST request successful!', result);
                alert("User Added");
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error while making POST request:', error);
            });
    };
    // console.log(tableData);

    function groupBySchoolWithPages(dataArray) {
        const grouped = [];

        dataArray.forEach(item => {
            const existing = grouped.find(g => g.schlId === item.schlId);

            const page = { pageId: item.pageId, pageNm: item.pageNm };

            if (existing) {
                // Only add page if it's not already present
                const alreadyExists = existing.pages.some(p => p.pageId === page.pageId);
                if (!alreadyExists) {
                    existing.pages.push(page);
                }
            } else {
                grouped.push({
                    schlId: item.schlId,
                    schlNm: item.schlNm,
                    schlcd: item.schlcd,
                    pages: [page]
                });
            }
        });

        return grouped;
    }


    const handleAdd = () => {
        const selectobj = schldata?.data?.find(item => item.ID === formData.schlId);
        const selectPgobj = upages?.data?.find(val => val.ID === formData.pageAss);
        if (!selectobj || !selectPgobj) return;

        const schlId = selectobj.ID;
        const selectedPageNm = selectPgobj.pages?.toLowerCase();

        // 🛑 If "All" is already assigned for this school
        const hasAllAssigned = tableData.some(
            entry => entry.schlId === schlId && entry.pageNm?.toLowerCase() === 'all'
        );
        if (hasAllAssigned) {
            alert(`"${selectobj.schlNm}" already has "All" pages assigned. Cannot assign other pages.`);
            return;
        }

        // 🛑 If trying to assign "All", but other pages already exist
        const hasOtherPagesAssigned = tableData.some(
            entry => entry.schlId === schlId && entry.pageNm?.toLowerCase() !== 'all'
        );
        if (selectedPageNm === 'all' && hasOtherPagesAssigned) {
            alert(`"${selectobj.schlNm}" already has specific pages assigned. Remove them before assigning "All".`);
            return;
        }

        // 🛑 Prevent duplicate (same school + same page)
        const isDuplicate = tableData.some(
            entry => entry.schlId === schlId && entry.pageId === selectPgobj.ID
        );
        if (isDuplicate) {
            alert(`"${selectPgobj.pages}" is already assigned to "${selectobj.schlNm}".`);
            return;
        }

        // ✅ Add new page assignment
        const data = {
            schlId: schlId,
            schlNm: selectobj.schlNm,
            schlcd: selectobj.schlcd,
            saleEntry: formData.saleEntry,
            stockReg: formData.stockReg,
            stockDetails: formData.stockDetails,
            delete: formData.delete,
            pageNm: selectPgobj.pages,
            pageId: selectPgobj.ID
        };

        setTableData(prev => [...prev, data]);

        setFormData(prev => ({
            ...prev,
            // saleEntry: '0',
            // stockDetails: '0',
            // stockReg: '0',
            // delete: '0',
            pageAss: ''

        }));
    };


    return (
        <>
            <Titlebar data={userMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>User Register Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={1.2}>

                                {fieldsecond?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                <Grid xs={6}>


                                </Grid>
                                {fieldsecond2?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            color={drop.color}
                                        />
                                    ))
                                }

                                {/* <CheckboxComponent
                                    label="Page Assign"
                                    options={checkboxOptions}
                                    values={formData}
                                    onChange={handleCheckboxChange}
                                /> */}

                                <Grid item xs={6} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleAdd}>Add</Button>
                                </Grid>


                                <Grid item xs={6} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleDelete}>Remove</Button>
                                </Grid>


                                {/* {Array.isArray(tableData) && tableData.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>School</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Code</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Page Assign</TableCell>

                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableData.length > 0
                                                        ? tableData?.map((form, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    <Checkbox
                                                                        checked={selectedRows.includes(index)}
                                                                        onChange={(e) => handleCheckboxChange2(e, index)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.schlNm}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.schlcd}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    {`${form.saleEntry !== '0' ? 'Sale Entry' : ''} `}
                                                                    {form.stockReg !== '0' ? <br /> : null}
                                                                    {`${form.stockReg !== '0' ? 'Stock Register' : ''} `}
                                                                    {form.stockDetails !== '0' ? <br /> : null}
                                                                    {`${form.stockDetails !== '0' ? 'Stock Details' : ''} `}
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.pageNm}</TableCell>
                                                            </TableRow>
                                                        ))
                                                        : ''}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </>
                                } */}


                                {Array.isArray(tableData) && tableData.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>School</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Code</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Page Assign</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {Object.values(
                                                        tableData.reduce((acc, item) => {
                                                            if (!acc[item.schlId]) {
                                                                acc[item.schlId] = {
                                                                    ...item,
                                                                    pageNmList: [item.pageNm]
                                                                };
                                                            } else {
                                                                acc[item.schlId].pageNmList.push(item.pageNm);
                                                            }
                                                            return acc;
                                                        }, {})
                                                    ).map((form, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedRows.includes(index)}
                                                                    onChange={(e) => handleCheckboxChange2(e, index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.schlNm}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.schlcd}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                {/* {form.pageNmList.join(', ')} */}

                                                                {form.pageNmList.map((name, idx) => (
                                                                    <span key={idx}>
                                                                        {name}
                                                                        {idx !== form.pageNmList.length - 1 && <br />}
                                                                    </span>
                                                                ))}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </>
                                }


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default UserRegEntry;
